import format from 'date-fns/format';

export default function (value?: Date | number | null | string): string {
  return value ? format(new Date(value), 'dd/MM/yyyy') : '';
}
